module.exports = __webpack_public_path__ + "static/img/6389_phase_function_Paper_Points.e14551e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6389_phase_function_Paper_Points.png
// module id = /NNr
// module chunks = 0